@if (count > 0) {
  @if (badge) {
    <span class="badge border-radius-sm"
          [ngClass]="badgeColor">
      <ng-template [ngTemplateOutlet]="linkOrText"/>
    </span>
  } @else {
    <ng-template [ngTemplateOutlet]="linkOrText"/>
  }
}

<ng-template #linkOrText>
  @if (showLink && redirectToActionManagerParams) {
    <a target="_blank"
       rel="opener"
       [routerLink]="['/tickets', 'escalated', 'search']"
       [queryParams]="redirectToActionManagerParams">
      <ng-template [ngTemplateOutlet]="text"/>
    </a>
  } @else {
    <ng-template [ngTemplateOutlet]="text"/>
  }
</ng-template>

<ng-template #text>
  @if (showFullMessage) {
    {{count === 1
      ? ('Actioned 1 other time' | messageTranslate)
      : ('Actioned other times' | messageTranslate:{times: count})}}
  } @else {
    {{count === 1
      ? ('1 other time' | messageTranslate)
      : ('other times'  | messageTranslate: {times: count})}}
  }
</ng-template>
